// schema.ts
import { getValidator } from "./utilities.mjs";
import { any } from "./validators/any.mjs";
function additionalProperties(options) {
  if (options === false) return { [Symbol.justusAdditionalValidator]: false };
  if (options === true) return { [Symbol.justusAdditionalValidator]: any };
  return { [Symbol.justusAdditionalValidator]: options ? getValidator(options) : any };
}
var allowAdditionalProperties = additionalProperties;
additionalProperties[Symbol.justusAdditionalValidator] = any;
export {
  allowAdditionalProperties
};
//# sourceMappingURL=schema.mjs.map
